import React from "react";
import { APPOINTMENT_STATUS } from "../../data/mockData";

const INVOICE_STATUS = {
  paid: { label: "Paid", tone: "success" },
  partial: { label: "Part paid", tone: "info" },
  unpaid: { label: "Unpaid", tone: "warning" },
  overdue: { label: "Overdue", tone: "danger" },
};

const StatusBadge = ({ status, type = "appointment" }) => {
  const map = type === "invoice" ? INVOICE_STATUS : APPOINTMENT_STATUS;
  const meta = map[status] || { label: status, tone: "neutral" };
  return <span className={`badge badge--${meta.tone}`}>{meta.label}</span>;
};

export default StatusBadge;
